export default __webpack_public_path__ + "e208950c980a3ca48a3f6812379d8bae.png";